var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnerHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_48580",
    "data-name": "Group 48580",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.934,
    height: 31.106,
    viewBox: "0 0 29.934 31.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24292",
    "data-name": "Rectangle 24292",
    width: 29.934,
    height: 31.106,
    fill: "#a1a3ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48579",
    "data-name": "Group 48579",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94735",
    "data-name": "Path 94735",
    d: "M25.889,12.949a9.181,9.181,0,0,1-.2,2.272c-.047.21-.1.248-.3.161a5.384,5.384,0,0,0-1.236-.355c-.183-.03-.219-.108-.2-.289A11.171,11.171,0,0,0,20.434,4.78a10.387,10.387,0,0,0-6.026-2.768A10.787,10.787,0,0,0,4.758,5.46a10.406,10.406,0,0,0-2.737,5.7,10.86,10.86,0,0,0,3.555,9.99,10.148,10.148,0,0,0,5.969,2.715,11.55,11.55,0,0,0,1.8.06c.277-.012.4.026.4.351a10.8,10.8,0,0,0,.119,1.362c.021.168.01.219-.184.227A12.955,12.955,0,0,1,.5,16.355,12.633,12.633,0,0,1,4.075,3.426,11.766,11.766,0,0,1,10.112.3,12.953,12.953,0,0,1,21.574,3.257,12.2,12.2,0,0,1,25.6,10.224a11.136,11.136,0,0,1,.292,2.725",
    transform: "translate(0 0)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94736",
    "data-name": "Path 94736",
    d: "M208.966,232.032a7.733,7.733,0,0,1-7.893-7.473,7.711,7.711,0,0,1,15.4-.819,7.765,7.765,0,0,1-7.506,8.292m-.231-13.628a5.788,5.788,0,0,0-5.893,6.056,5.928,5.928,0,1,0,5.893-6.056",
    transform: "translate(-186.557 -200.932)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94737",
    "data-name": "Path 94737",
    d: "M115.705,106.083a1.486,1.486,0,0,1-1.486-1.68.528.528,0,0,0-.155-.449q-1.446-1.834-2.89-3.671c-.081-.1-.161-.209-.233-.319a.653.653,0,0,1,.088-.957.727.727,0,0,1,1.03.121c.687.831,1.359,1.675,2.036,2.514.361.448.719.9,1.082,1.345.081.1.152.21.319.188a1.03,1.03,0,0,1,.854.167c.129.107.187-.052.259-.108,1.146-.888,2.285-1.784,3.433-2.669.473-.365.793-.36,1.068-.024a.793.793,0,0,1-.248,1.155q-1.574,1.255-3.164,2.489a1.186,1.186,0,0,0-.5.731,1.5,1.5,0,0,1-1.487,1.167",
    transform: "translate(-102.782 -91.714)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94738",
    "data-name": "Path 94738",
    d: "M46.073,168.221c.275,0,.551-.014.825,0a.567.567,0,0,1,.558.621.6.6,0,0,1-.537.645c-.549.022-1.1.027-1.65.005a.557.557,0,0,1-.55-.654.571.571,0,0,1,.6-.615c.131-.006.263,0,.395,0h.359v-.009",
    transform: "translate(-41.491 -156.076)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94739",
    "data-name": "Path 94739",
    d: "M169.86,268.713c0-.264-.012-.528,0-.791.024-.408.234-.608.605-.6a.594.594,0,0,1,.669.593q.027.808,0,1.618a.618.618,0,0,1-.683.623.6.6,0,0,1-.609-.651c-.006-.264,0-.528,0-.791h.013",
    transform: "translate(-157.588 -248.029)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94740",
    "data-name": "Path 94740",
    d: "M169.887,48.059c0-.252-.006-.5,0-.756a.586.586,0,0,1,.567-.653.666.666,0,0,1,.712.615,15.512,15.512,0,0,1,0,1.583.641.641,0,1,1-1.28-.068c0-.24,0-.48,0-.72Z",
    transform: "translate(-157.624 -43.282)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94741",
    "data-name": "Path 94741",
    d: "M276.867,168.434c.252,0,.5-.005.755,0a.631.631,0,0,1,.148,1.24,8.336,8.336,0,0,1-1.895.008.552.552,0,0,1-.4-.665.58.58,0,0,1,.535-.573c.024,0,.048,0,.072,0h.791v-.009",
    transform: "translate(-255.583 -156.277)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94742",
    "data-name": "Path 94742",
    d: "M272.142,276.062q0-1.495,0-2.989c0-.515.148-.661.664-.662.216,0,.432,0,.648.005.458.012.592.145.594.614,0,1.225,0,2.449,0,3.674a8.135,8.135,0,0,1-.009.828c-.028.269.079.308.318.3.8-.014,1.609-.009,2.413,0,.477,0,.676.211.681.678,0,.24.007.481-.006.72a.527.527,0,0,1-.549.542q-2.107.012-4.214,0c-.38,0-.549-.231-.548-.688,0-.936.006-1.873.01-2.809,0-.072,0-.144,0-.216Z",
    transform: "translate(-252.498 -252.752)",
    fill: "#a1a3ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerHours);
export default __webpack_public_path__ + "static/media/LearnerHours.04e346f5b4d33af6d557f5cba1522364.svg";
export { ForwardRef as ReactComponent };